import { NavLink } from "react-router-dom";
import { CSS } from "../../styles";

const SIDEBAR_W = 220;

const NAV = [
  { label: "Tableau de bord", icon: "◈", to: "/admin", end: true },
  { label: "Architectes", icon: "▲", to: "/admin/architects" },
  { label: "Projets", icon: "⬡", to: "/admin/projects" },
  { label: "Utilisateurs",  icon: "◆", to: "/admin/users" },
  { label: "Communication", icon: "✉", to: "/admin/communication" },
];

export default function AdminLayout({ children, userName }) {
  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#0F0E0C", fontFamily: "'DM Sans', sans-serif", color: "#E8E2D8" }}>
      <style>{CSS}</style>

      {/* Sidebar */}
      <aside style={{
        width: SIDEBAR_W, background: "#111009", borderRight: "1px solid #2A2924",
        display: "flex", flexDirection: "column", position: "fixed", top: 0, left: 0, bottom: 0,
      }}>
        <div style={{ padding: "20px 16px", borderBottom: "1px solid #2A2924", display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 28, height: 28, background: "#C9A96E", borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, flexShrink: 0 }}>⬡</div>
          <span style={{ fontFamily: "'DM Serif Display', serif", fontSize: 16, fontWeight: 400 }}>Travea</span>
          <span style={{ fontSize: 9, color: "#C9A96E", background: "#C9A96E18", border: "1px solid #C9A96E40", borderRadius: 4, padding: "1px 5px", fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase" }}>Admin</span>
        </div>

        <nav style={{ padding: "12px 10px", flex: 1 }}>
          {NAV.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              style={({ isActive }) => ({
                display: "flex", alignItems: "center", gap: 10,
                padding: "9px 10px", borderRadius: 8, marginBottom: 2,
                color: isActive ? "#C9A96E" : "#7A7468",
                background: isActive ? "#C9A96E12" : "transparent",
                textDecoration: "none", fontSize: 13,
                fontWeight: isActive ? 600 : 400,
                transition: "all .15s",
              })}
            >
              <span style={{ fontSize: 12, flexShrink: 0 }}>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Main area */}
      <div style={{ marginLeft: SIDEBAR_W, flex: 1, display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        {/* Header */}
        <header style={{
          height: 56, borderBottom: "1px solid #2A2924",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "0 28px", background: "#0F0E0C",
          position: "sticky", top: 0, zIndex: 50,
        }}>
          <span style={{ fontFamily: "'DM Serif Display', serif", fontSize: 18 }}>Travea Admin</span>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{
              width: 28, height: 28, borderRadius: "50%",
              background: "#252420", border: "1px solid #2A2924",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 12, color: "#C9A96E",
            }}>◆</div>
            <span style={{ fontSize: 13 }}>{userName}</span>
          </div>
        </header>

        {/* Content */}
        <main style={{ flex: 1, padding: 28 }}>
          {children}
        </main>
      </div>
    </div>
  );
}
